import React, { Component, createRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Popup from "reactjs-popup";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import SimpleReactValidator from "simple-react-validator";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { PopupMessage } from "../../utils/utils";
import { leaseDateFormat } from "../../utils/utils";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class RentalDetails extends Component {
  countError = "";
  state = {
    isEdit: false,
    escalationIndex: 0,
    disableBifurctaeUnit: false,
    totalGla: "",
    periodDurationDD: "",
    periodDurationYY: "",
    periodDurationMM: "",
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    productName: "",
    productId: "",
    to: "",
    index_val: "",
    delete: false,
    revalue: "",
    showAddBtn: false,
    isOpen: false,
    showForm: true,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    rentalDetails: [],
    products: [],
    redirect: false,
    rentMinusCam: false,
    rentFitoutMinusCam: false,
    pureRevenueShareMinusCam: false,
    pureRevenueSalesShareMinusCam: false,
    pureRevenueProduct: false,
    pureRevenueSalesProduct: false,
    minimumGuaranteeRentPlusCam: false,
    minimumGuaranteeRentPlusFitout: false,
    minimumGuaranteeRentRevenueShareSalesRange: false,
    minimumGuaranteeRentRevenueShareProduct: false,
    minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
    minimumGuaranteeRentRevenueShareMinimum: false,
    initialValues: {
      rentalLogic: {
        fromDate: "",
        toDate: "",
        rentalUom: "",
        rentDueDate: "",
        rentRate: "",
        rentRateTerm: "",
        onArea: "",
        rentFrequency: "",
        rentalLogicValue: "",
        rentalLogicText: "",
        minusCamPercent: "",
        revenueShareTerm: "",
        slabs: [],
        unit: "",
      },
      totalSlabs: "",
    },
    showMinusCam: false,
    biFurcateRentVal: 0,
    units: [],
    isUnitBifurcate: false,
    isRentAutocalculate: false,
    isRentCheckboxChecked: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!",
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.formikRef = createRef();
  }

  handleReset = () => {
    // console.log('Reset button clicked');
    // if (this.formikRef.current) {
    //   console.log('Resetting form');
    //   this.formikRef.current.resetForm();
    // } else {
    //   console.warn('Formik reference is not set yet');
    // }

    var _initialValues = this.state.initialValues;
    _initialValues.rentalLogic.rentalLogicValue = "";
    _initialValues.rentalLogic.slabs = [];
    this.state.initialValues.totalSlabs = "";
    this.setState({
      // rentalDetails: _rentalDetails,
      rentMinusCam: false,
      rentFitoutMinusCam: false,
      pureRevenueShareMinusCam: false,
      pureRevenueSalesShareMinusCam: false,
      pureRevenueProduct: false,
      pureRevenueSalesProduct: false,
      minimumGuaranteeRentPlusCam: false,
      minimumGuaranteeRentPlusFitout: false,
      minimumGuaranteeRentRevenueShareSalesRange: false,
      minimumGuaranteeRentRevenueShareProduct: false,
      minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
      minimumGuaranteeRentRevenueShareMinimum: false,
    });
    //this.state.period++;
    // this.state.fromDate = this.state.toDate;
    this.state.periodTermDD = "";
    this.state.periodTermMM = "";
    this.state.periodTermYY = "";
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.rentalDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
  };

  biFurcateRent(e, values) {
    if (this.state.rentalDetails.length > 0) {
      var answer = window.confirm(
        "This will remove all the current rental details, are you sure want to do this?"
      );
      if (answer) {
        this.setState({
          rentalDetails: [],
          period: 1,
          showForm: true,
          showAddBtn: true,
          fromDate: values.from,
        });
        if (e.target.checked) {
          this.setState({ biFurcateRentVal: 1 });
        } else {
          this.setState({ biFurcateRentVal: 0 });
        }
      } else {
        return false;
      }
    } else {
      if (e.target.checked) {
        this.setState({ biFurcateRentVal: 1 });
      } else {
        this.setState({ biFurcateRentVal: 0 });
      }
    }
    if (this.state.isUnitBifurcate === false) {
      this.setState({ isUnitBifurcate: true });
    } else {
      this.setState({ isUnitBifurcate: false });
    }
  }

  handleUnitOnChange(e, values, setFieldValue) {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    setFieldValue("rentalLogic.rentRate", "");
    setFieldValue("rentalLogic.escalationPercent", "");
    this.state.initialValues.rentalLogic.unit = e.target.value;
    this.setState({});
    if (this.state.rentalDetails.length > 0) {
      var bifurcatedArr = this.state.rentalDetails.filter(
        (unit) => unit.unit === e.target.value
      );
      if (bifurcatedArr.length > 0) {
        if (bifurcatedArr[bifurcatedArr.length - 1]["toDate"] === values.to) {
          this.setState({
            popupalertMessage: true,
            popupMessageContent:
              "Values For this unit has completed the period",
          });
          return false;
        }
        this.state.period = bifurcatedArr[bifurcatedArr.length - 1].period + 1;
        this.setState({
          fromDate: getToDate(
            bifurcatedArr[bifurcatedArr.length - 1].toDate,
            2,
            0,
            0
          ),
          toDate: "",
        });
      } else {
        this.state.period = 1;
        this.state.fromDate = values.from;
        this.setState({});
      }
    } else {
      this.state.period = 1;
      this.state.fromDate = values.from;
      this.setState({});
    }
  }

  autocalculateRent = (e, values) => {
    if (this.state.rentalDetails.length > 0) {
      var answer = window.confirm(
        "This will remove all the current rental details, are you sure want to do this?"
      );
      if (answer) {
        this.setState(
          {
            rentalDetails: [],
            period: 1,
            showForm: true,
            showAddBtn: true,
          },
          () => {
            console.log(this.state.rentalDetails);
          }
        );
        if (e.target.checked) {
          this.setState({
            isRentAutocalculate: true,
            isRentCheckboxChecked: true,
          });
        } else {
          this.setState({
            isRentAutocalculate: false,
          });
        }
      } else {
        this.setState({
          isRentCheckboxChecked: false,
          isRentAutocalculate: false,
        });
        return false;
      }
    }
    if (this.state.isRentCheckboxChecked === false) {
      this.setState({ isRentCheckboxChecked: true, isRentAutocalculate: true });
    } else {
      this.setState({
        isRentCheckboxChecked: false,
        isRentAutocalculate: false,
        fromDate: values.from,
      });
    }
  };

  changeProduct(newValue, values, index) {
    this.state.initialValues.rentalLogic.slabs[index].product = newValue.value;
    this.state.initialValues.rentalLogic.slabs[index].productName =
      newValue.label;
    this.setState({});
    console.groupEnd();
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  editRental(index, values) {
    this.setState({ isEdit: true, escalationIndex: index - 1 });
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (this.state.rentalDetails[index].unit !== undefined) {
      this.setState({ isUnitBifurcate: true, biFurcateRentVal: 1 });
    } else {
      this.setState({ isUnitBifurcate: false, biFurcateRentVal: 0 });
    }
    if (this.state.rentalDetails[index].rentalLogic !== undefined) {
      if (
        this.state.rentalDetails[index].rentalLogic.escalationPercent !==
        undefined
      ) {
        this.setState({
          isRentAutocalculate: true,
          isRentCheckboxChecked: true,
        });
      } else {
        this.setState({
          isRentAutocalculate: false,
          isRentCheckboxChecked: false,
        });
      }
    } else {
      this.setState({
        isRentAutocalculate: false,
        isRentCheckboxChecked: false,
      });
    }

    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    this.state.period = this.state.rentalDetails[index].period;
    this.state.initialValues.totalSlabs =
      this.state.rentalDetails[index].slabNumber;
    if (this.state.rentalDetails[index].rentalLogicText.includes("Minus CAM")) {
      this.setState({
        showMinusCam: true,
      });
    } else {
      this.setState({
        showMinusCam: false,
      });
    }
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.rentalDetails[index].periodTermDD,
      periodTermMM: this.state.rentalDetails[index].periodTermMM,
      periodTermYY: this.state.rentalDetails[index].periodTermYY,
    });
    if (
      this.state.rentalDetails[index].rentalLogicValue === "1" ||
      this.state.rentalDetails[index].rentalLogicValue === "2"
    ) {
      this.setState({
        rentMinusCam: true,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "3" ||
      this.state.rentalDetails[index].rentalLogicValue === "4"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: true,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "5" ||
      this.state.rentalDetails[index].rentalLogicValue === "6"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: true,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "7" ||
      this.state.rentalDetails[index].rentalLogicValue === "8"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: true,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "9" ||
      this.state.rentalDetails[index].rentalLogicValue === "10"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: true,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "11" ||
      this.state.rentalDetails[index].rentalLogicValue === "12"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: true,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "13" ||
      this.state.rentalDetails[index].rentalLogicValue === "14" ||
      this.state.rentalDetails[index].rentalLogicValue === "15"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: true,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "16" ||
      this.state.rentalDetails[index].rentalLogicValue === "17"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: true,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "18" ||
      this.state.rentalDetails[index].rentalLogicValue === "19" ||
      this.state.rentalDetails[index].rentalLogicValue === "28"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: true,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "20" ||
      this.state.rentalDetails[index].rentalLogicValue === "21"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: true,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "22" ||
      this.state.rentalDetails[index].rentalLogicValue === "23"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: true,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      this.state.rentalDetails[index].rentalLogicValue === "24" ||
      this.state.rentalDetails[index].rentalLogicValue === "25" ||
      this.state.rentalDetails[index].rentalLogicValue === "26" ||
      this.state.rentalDetails[index].rentalLogicValue === "27"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: true,
      });
    } else {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    }
    values.rentalLogic = { ...this.state.rentalDetails[index] };
    this.state.fromDate = this.state.rentalDetails[index].fromDate;
    this.state.toDate = this.state.rentalDetails[index].toDate;
    this.state.initialValues.rentalLogic.unit =
      this.state.rentalDetails[index].unit;
    this.setState({});
  }

  calculateRent = (values) => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      return false;
    }
    let currentValues = values;
    let nextPeriodDateStart = currentValues.from;
    let _rentalDetails = this.state.rentalDetails;
    let currentPeriod = 0;
    var periodToDate;
    var endDate = currentValues.to;
    var escPercent = Number(currentValues.rentalLogic.escalationPercent);
    while (periodToDate !== endDate) {
      currentPeriod++;
      var periodStartDate = nextPeriodDateStart;
      periodToDate = getToDate(
        periodStartDate,
        this.state.periodDurationDD,
        this.state.periodDurationMM,
        this.state.periodDurationYY
      );
      if (
        new Date(periodToDate).getTime() > new Date(currentValues.to).getTime()
      ) {
        periodToDate = currentValues.to;
      }
      if (currentValues.rentalLogic.rentalUom != "Per Seat") {
        if (currentPeriod > 1) {
          currentValues.rentalLogic.rentRate = (
            Number(currentValues.rentalLogic.rentRate) *
              (Number(currentValues.rentalLogic.escalationPercent) / 100) +
            Number(currentValues.rentalLogic.rentRate)
          ).toFixed(2);
        }
      }

      var rentalLogic = { ...currentValues.rentalLogic };
      console.log(rentalLogic, "11");
      var _currentValues = {
        fromDate: periodStartDate,
        toDate: periodToDate,
        rentalLogicText: this.state.initialValues.rentalLogic.rentalLogicText,
        rentalLogicValue: this.state.initialValues.rentalLogic.rentalLogicValue,
        periodDurationDD: this.state.periodDurationDD,
        periodDurationMM: this.state.periodDurationMM,
        periodDurationYY: this.state.periodDurationYY,
        periodTermDD: this.state.periodDurationDD,
        periodTermMM: this.state.periodDurationMM,
        periodTermYY: this.state.periodDurationYY,
        period: currentPeriod,
        slabs: [],
        escalationPercent: rentalLogic.escalationPercent,
        rentalUom: rentalLogic.rentalUom,
        onArea: rentalLogic.onArea,
        rentRateTerm: rentalLogic.rentRateTerm,
        rentRate: rentalLogic.rentRate,
        seatRate: rentalLogic.seatRate,
        seatCount: rentalLogic.seatCount,
        rentFrequency: rentalLogic.rentFrequency,
        rentDueDate: rentalLogic.rentDueDate,
        rentDueType: rentalLogic.rentDueType,
        rentDueFrequency: rentalLogic.rentDueFrequency,
        fitoutUom: rentalLogic.fitoutUom,
        fitoutOnArea: rentalLogic.fitoutOnArea,
        fitoutRate: rentalLogic.fitoutRate,
        fitoutFrequency: rentalLogic.fitoutFrequency,
        fitoutRateTerm: rentalLogic.fitoutRateTerm,
        minusCamPercent: rentalLogic.minusCamPercent,
        unit: rentalLogic.unit,
      };
      console.log(_currentValues);
      _rentalDetails.push(_currentValues);
      nextPeriodDateStart = getToDate(periodToDate, 2, 0, 0);
    }
    this.setState({ rentalDetails: _rentalDetails });
    values.rentalLogic.escalationPercent = "";
    values.rentalLogic.rentRate = "";
    this.setState({
      periodDurationDD: "",
      periodDurationMM: "",
      periodDurationYY: "",
      showAddBtn: false,
      showForm: false,
    });
  };

  addRentalDetails = (values, resetForm, setFieldValue) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });

        return false;
      } else if (this.state.toDate == values.to) {
        if (this.state.biFurcateRentVal === 0) {
          this.state.showForm = false;
          this.state.showAddBtn = false;
        }
      }
      values.rentalLogic.rentalLogicText =
        this.state.initialValues.rentalLogic.rentalLogicText;
      var rentalVal = this.state.initialValues.rentalLogic.rentalLogicValue;
      var _rentalDetails = this.state.rentalDetails;
      values.rentalLogic.period = this.state.period;
      values.rentalLogic.fromDate = this.state.fromDate;
      values.rentalLogic.toDate = this.state.toDate;
      values.rentalLogic.periodTermYY = this.state.periodTermYY;
      values.rentalLogic.periodTermMM = this.state.periodTermMM;
      values.rentalLogic.periodTermDD = this.state.periodTermDD;
      values.rentalLogic.slabs = this.state.initialValues.rentalLogic.slabs;
      values.rentalLogic.unit = this.state.initialValues.rentalLogic.unit;
      _rentalDetails.push(values.rentalLogic);
      var _initialValues = this.state.initialValues;
      // _initialValues.rentalLogic.rentalLogicValue = "";
      _initialValues.rentalLogic.slabs = [];
      this.state.initialValues.totalSlabs = "";
      this.setState({
        rentalDetails: _rentalDetails,
        // rentMinusCam: false,
        // rentFitoutMinusCam: false,
        // pureRevenueShareMinusCam: false,
        // pureRevenueSalesShareMinusCam: false,
        // pureRevenueProduct: false,
        // pureRevenueSalesProduct: false,
        // minimumGuaranteeRentPlusCam: false,
        // minimumGuaranteeRentPlusFitout: false,
        // minimumGuaranteeRentRevenueShareSalesRange: false,
        // minimumGuaranteeRentRevenueShareProduct: false,
        // minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        // minimumGuaranteeRentRevenueShareMinimum: false,
      });
      this.state.period++;
      this.state.periodTermDD = "";
      this.state.periodTermMM = "";
      this.state.periodTermYY = "";
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.rentalDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      setFieldValue("rentalLogic.rentRate", "");
      setFieldValue("rentalLogic.seatRate", "");
      setFieldValue("rentalLogic.escalationPercent", "");
      this.setState({ isEdit: false, escalationIndex: this.state.period - 2 });
      // resetForm();
    } else {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      } else if (this.state.toDate == values.to) {
        if (this.state.biFurcateRentVal === 0) {
          this.state.showForm = false;
          this.state.showAddBtn = false;
        }
      }
      values.rentalLogic.rentalLogicText =
        this.state.initialValues.rentalLogic.rentalLogicText;
      var _rentalDetails = this.state.rentalDetails;
      values.rentalLogic.period = this.state.period;
      values.rentalLogic.fromDate = this.state.fromDate;
      values.rentalLogic.toDate = this.state.toDate;
      values.rentalLogic.periodTermYY = this.state.periodTermYY;
      values.rentalLogic.periodTermMM = this.state.periodTermMM;
      values.rentalLogic.periodTermDD = this.state.periodTermDD;
      values.rentalLogic.slabs = this.state.initialValues.rentalLogic.slabs;
      _rentalDetails[this.state.currentIndex] = { ...values.rentalLogic };
      var _initialValues = this.state.initialValues;
      _initialValues.rentalLogic.rentalLogicValue = "";
      _initialValues.rentalLogic.slabs = [];
      this.state.initialValues.totalSlabs = "";
      this.setState({
        rentalDetails: _rentalDetails,
        // rentMinusCam: false,
        // rentFitoutMinusCam: false,
        // pureRevenueShareMinusCam: false,
        // pureRevenueSalesShareMinusCam: false,
        // pureRevenueProduct: false,
        // pureRevenueSalesProduct: false,
        // minimumGuaranteeRentPlusCam: false,
        // minimumGuaranteeRentPlusFitout: false,
        // minimumGuaranteeRentRevenueShareSalesRange: false,
        // minimumGuaranteeRentRevenueShareProduct: false,
        // minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        // minimumGuaranteeRentRevenueShareMinimum: false,
      });
      this.state.period++;
      this.state.periodTermDD = "";
      this.state.periodTermMM = "";
      this.state.periodTermYY = "";
      // values.rentalLogic.unit = "";
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.rentalDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      // resetForm();
      this.state.currentIndex = null;
      this.state.disableOnEdit = false;
      this.state.readOnEdit = false;
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
    }
  };

  resetRentalDetails = (values, resetForm) => {
    var _initialValues = this.state.initialValues;
    _initialValues.rentalLogic.rentalLogicValue = "";
    _initialValues.rentalLogic.slabs = [];
    this.state.initialValues.totalSlabs = "";
    this.setState({
      // rentalDetails: _rentalDetails,
      rentMinusCam: false,
      rentFitoutMinusCam: false,
      pureRevenueShareMinusCam: false,
      pureRevenueSalesShareMinusCam: false,
      pureRevenueProduct: false,
      pureRevenueSalesProduct: false,
      minimumGuaranteeRentPlusCam: false,
      minimumGuaranteeRentPlusFitout: false,
      minimumGuaranteeRentRevenueShareSalesRange: false,
      minimumGuaranteeRentRevenueShareProduct: false,
      minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
      minimumGuaranteeRentRevenueShareMinimum: false,
    });
    this.state.period = this.state.rentalDetails.length + 1;
    //this.state.period++;
    // this.state.fromDate = this.state.toDate;
    this.state.periodTermDD = "";
    this.state.periodTermMM = "";
    this.state.periodTermYY = "";
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.rentalDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    resetForm();
  };

  addSlabRow = (e) => {
    this.state.initialValues.totalSlabs = e.target.value;
    if (this.state.initialValues.rentalLogic.slabs.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.rentalLogic.slabs.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.rentalLogic.slabs.push({
          from: "",
          to: "",
          percent: "",
          product: "",
        });
      }
    } else if (
      this.state.initialValues.rentalLogic.slabs.length > e.target.value
    ) {
      var toRemove =
        this.state.initialValues.rentalLogic.slabs.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.rentalLogic.slabs.pop({});
      }
    }
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.rentalLogic.slabs[index + 1].from =
      Number(e.target.value) + Number(1);
    this.setState({});
  }

  handleRentalLogicChange = (event, values) => {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    values.rentalLogic.rentalUom = "";
    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    let index = event.nativeEvent.target.selectedIndex;
    let label = event.nativeEvent.target[index].label;
    this.state.initialValues.rentalLogic.rentalLogicText = label;
    this.state.initialValues.rentalLogic.rentalLogicValue = event.target.value;
    let checkValue = label.includes("Minus CAM");
    if (checkValue) {
      this.setState({
        showMinusCam: true,
      });
    } else {
      this.setState({
        showMinusCam: false,
      });
    }
    if (event.target.value === "1" || event.target.value === "2") {
      this.setState({
        rentMinusCam: true,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "3" || event.target.value === "4") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: true,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "5" || event.target.value === "6") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: true,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "7" || event.target.value === "8") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: true,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "9" || event.target.value === "10") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: true,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "11" || event.target.value === "12") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: true,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      event.target.value === "13" ||
      event.target.value === "14" ||
      event.target.value === "15"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: true,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "16" || event.target.value === "17") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: true,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      event.target.value === "18" ||
      event.target.value === "19" ||
      event.target.value === "28"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: true,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "20" || event.target.value === "21") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: true,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (event.target.value === "22" || event.target.value === "23") {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: true,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    } else if (
      event.target.value === "24" ||
      event.target.value === "25" ||
      event.target.value === "26" ||
      event.target.value === "27"
    ) {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: true,
      });
    } else {
      this.setState({
        rentMinusCam: false,
        rentFitoutMinusCam: false,
        pureRevenueShareMinusCam: false,
        pureRevenueSalesShareMinusCam: false,
        pureRevenueProduct: false,
        pureRevenueSalesProduct: false,
        minimumGuaranteeRentPlusCam: false,
        minimumGuaranteeRentPlusFitout: false,
        minimumGuaranteeRentRevenueShareSalesRange: false,
        minimumGuaranteeRentRevenueShareProduct: false,
        minimumGuaranteeRentRevenueShareSalesRangeProduct: false,
        minimumGuaranteeRentRevenueShareMinimum: false,
      });
    }
  };

  componentDidMount() {
    let athis = this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-details?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      athis.state.totalGla = data.total_gla;
      athis.state.isRentAutocalculate = data.isRentAutocalculate;
      athis.state.isUnitBifurcate = data.isUnitBifurcate;
      if (data.isRentAutocalculate) {
        athis.setState({ isRentCheckboxChecked: true });
      } else {
        athis.setState({ isRentCheckboxChecked: false });
      }
      if (data.isUnitBifurcate === true) {
        athis.setState({ biFurcateRentVal: 1 });
      } else {
        athis.setState({ biFurcateRentVal: 0 });
      }
      athis.state.to = data.to;
      athis.state.fromDate = data.from;
      if (data.rentalDetails.length > 0) {
        if (
          data.rentalDetails[data.rentalDetails.length - 1].toDate == data.to
        ) {
          athis.setState({
            showForm: false,
          });
        }
        
        athis.setState({
          fromDate: getToDate(
            data.rentalDetails[data.rentalDetails.length - 1].toDate,
            2,
            0,
            0
          ),
        });
      }
      athis.setState({
        initialValues: data,
        rentalDetails: data.rentalDetails,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        period:
          data.rentalDetails.length > 0 ? data.rentalDetails.length + 1 : 1,
        units: data.units,
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.totalGla = data.total_gla;
    //     this.state.isRentAutocalculate = data.isRentAutocalculate;
    //     this.state.isUnitBifurcate = data.isUnitBifurcate;
    //     if (data.isRentAutocalculate) {
    //       this.setState({ isRentCheckboxChecked: true });
    //     } else {
    //       this.setState({ isRentCheckboxChecked: false });
    //     }
    //     if (data.isUnitBifurcate === true) {
    //       this.setState({ biFurcateRentVal: 1 });
    //     } else {
    //       this.setState({ biFurcateRentVal: 0 });
    //     }
    //     this.state.to = data.to;
    //     this.state.fromDate = data.from;
    //     if (data.rentalDetails.length > 0) {
    //       if (
    //         data.rentalDetails[data.rentalDetails.length - 1].toDate == data.to
    //       ) {
    //         this.setState({
    //           showForm: false,
    //         });
    //       }
    //       // let _tempDate = new Date(
    //       //   data.rentalDetails[data.rentalDetails.length - 1].toDate
    //       // );

    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // console.log(dd, mm, y);
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.rentalDetails[data.rentalDetails.length - 1].toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       rentalDetails: data.rentalDetails,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       period:
    //         data.rentalDetails.length > 0 ? data.rentalDetails.length + 1 : 1,
    //       units: data.units,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    fetch(`${apiUrl.apiUrl.url}/product-master/get-all-products`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          products: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  calculateToDate(values) {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        Number(this.state.periodTermMM),
        this.state.periodTermYY
      ),
    });
  }

  calculateRentRate(e, values, setFieldValue) {
    if (this.state.period > 1) {
      if (values.rentalLogic.rentalUom != "Per Seat") {
        setFieldValue(
          "rentalLogic.rentRate",
          (
            Number(
              this.state.rentalDetails[this.state.rentalDetails.length - 1]
                .rentRate
            ) *
            (1 + Number(e.target.value) / 100)
          ).toFixed(2)
        );
      } else {
        setFieldValue(
          "rentalLogic.seatRate",
          (
            Number(
              this.state.rentalDetails[this.state.rentalDetails.length - 1]
                .seatRate
            ) *
            (1 + Number(e.target.value) / 100)
          ).toFixed(2)
        );
      }
    }
  }

  fetchUnitDetails(e, setFieldValue) {
    console.log(e.target.value, "eeee", this.props.match.params.id);

    fetch(
      `${apiUrl.apiUrl.url}/create-lease/fetch-coworking-details?id=${this.props.match.params.id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setFieldValue("rentalLogic.seatCount", data.total_sum);
      });
  }

  calculateEscalationPercent(e, values, setFieldValue, str) {
    if (this.state.period > 1) {
      if (values.rentalLogic.rentalUom != "Per Seat") {
        if (str == "uom") {
          setFieldValue(
            "rentalLogic.escalationPercent",
            (
              ((Number(values.rentalLogic.rentRate) -
                Number(
                  this.state.rentalDetails[this.state.escalationIndex].rentRate
                )) /
                Number(
                  this.state.rentalDetails[this.state.escalationIndex].rentRate
                )) *
              100
            ).toFixed(2)
          );
        } else {
          if (
            this.state.rentalDetails[this.state.escalationIndex].rentRate !== 0
          ) {
            setFieldValue(
              "rentalLogic.escalationPercent",
              (
                ((Number(e.target.value) -
                  Number(
                    this.state.rentalDetails[this.state.escalationIndex]
                      .rentRate
                  )) /
                  Number(
                    this.state.rentalDetails[this.state.escalationIndex]
                      .rentRate
                  )) *
                100
              ).toFixed(1)
            );
          }
        }
      } else {
        setFieldValue(
          "rentalLogic.escalationPercent",
          (
            ((Number(e.target.value) -
              Number(
                this.state.rentalDetails[this.state.escalationIndex].seatRate
              )) /
              Number(
                this.state.rentalDetails[this.state.escalationIndex].seatRate
              )) *
            100
          ).toFixed(2)
        );
      }
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _rentals = this.state.rentalDetails;

    this.setState({ period: _rentals.length });

    _rentals.splice(this.state.index_val, 1);

    this.setState({
      rentalDetails: _rentals,
      showForm: true,
    });
    //this.state.period--;

    if (this.state.rentalDetails.length > 0) {
      this.setState({
        fromDate: getToDate(
          this.state.rentalDetails[this.state.rentalDetails.length - 1].toDate,
          2,
          0,
          0
        ),
      });
    } else {
      this.setState({
        fromDate: this.state.revalue,
      });
    }
    this.setState({
      delete: false,
      index_val: "",
      revalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  calculateTotalSeatAmount = (e, values, x) => {
    if (x == "count") {
      if (
        values.rentalLogic.seatRate != undefined &&
        values.rentalLogic.seatRate != null
      ) {
        values.rentalLogic.seatTotalAmount =
          e.target.value * values.rentalLogic.seatRate;
        this.setState({});
      }
    } else {
      if (
        values.rentalLogic.seatCount != undefined &&
        values.rentalLogic.seatCount != null
      ) {
        values.rentalLogic.seatTotalAmount =
          e.target.value * values.rentalLogic.seatCount;
        this.setState({});
      }
    }
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;

      return (
        <Redirect
          push
          to={`/${urlPath[1]}/other-rental-details/` + this.props.match.params.id}
        />
      );
    }
    return (
      <div className="parentContainer createLease">
        <div>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Create Lease</li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                </li>
                <li>Commercial Details</li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                </li>
                <li>
                  <a href="#">Basic Rental Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            innerRef={this.formikRef}
            enableReinitialize
            onSubmit={(values, actions) => {
              if (this.state.rentalDetails.length == 0) {
                this.mainFormValidator.showMessages("countError");
                return false;
              }
              if (this.state.biFurcateRentVal === 0) {
                if (
                  this.state.to !==
                  this.state.rentalDetails[this.state.rentalDetails.length - 1]
                    .toDate
                ) {
                  this.setState({
                    popupalertMessage: true,
                    popupMessageContent: "Please Complete the period",
                  });
                  return false;
                }
              }
              values.rentalDetails = this.state.rentalDetails;
              values.isRentAutocalculate = this.state.isRentAutocalculate;
              values.isUnitBifurcate = this.state.isUnitBifurcate;
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/create-lease/update-lease-rent-details?lease_id=${this.props.match.params.id}`,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({ messsagePopup: true });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
              resetForm,
              setFieldValue,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off" >
                    <div className="newGridSectionParent">
                      <div className="d-flex gap-5">
                        <label>
                          <Field
                            style={{ width: "min-content" }}
                            type="checkbox"
                            name="bifurcateRentCheckBox"
                            value="bifurcateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isUnitBifurcate}
                            disabled={
                              typeof this.state.units != "undefined" &&
                              this.state.units.length === 1
                                ? true
                                : false
                            }
                            onClick={(e) => {
                              this.biFurcateRent(e, values);
                            }}
                          />
                          BiFurcate Rent
                        </label>
                        <label>
                          <Field
                            style={{ width: "min-content" }}
                            type="checkbox"
                            name="autocalculateRentCheckBox"
                            value="autocalculateRentCheckBox"
                            className="sameAs me-2"
                            checked={this.state.isRentCheckboxChecked}
                            onClick={(e) => {
                              this.autocalculateRent(e, values);
                            }}
                          />
                          Autocalculate Rent
                        </label>
                      </div>
                      <div className="gridColOneByThree textWithHrTag">
                        <hr className="m-0 my-4" />
                      </div>
                      <div className="newGridSectionForFormMain">
                        <div className="newGridSectionInner">
                          <label>
                            Lease Term <br /> (YY-MM-DD){" "}
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermYY}
                                />
                              </div>
                              <div className="col-4">
                                <Field
                                  type="text"
                                  name="leaseTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermMM}
                                />
                              </div>
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.leaseTermDD}
                                />
                              </div>
                            </div>
                            <ErrorMessage
                              name="leaseTerm"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>
                            Lease Renewal Term <br /> (YY-MM-DD){" "}
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermYY}
                                />
                              </div>
                              <div className="col-4">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermMM}
                                />
                              </div>
                              <div className="col-4 p-0">
                                <Field
                                  type="text"
                                  name="leaseRenewalTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder text-center"
                                  value={this.state.renewalLeaseTermDD}
                                />
                              </div>
                            </div>
                            <ErrorMessage
                              name="leaseRenewalTerm"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>From</label>
                          <div className="position-relative">
                            <Field type="date" name="from" />
                            <ErrorMessage
                              name="from"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        <div className="newGridSectionInner">
                          <label>To</label>
                          <div className="position-relative">
                            <Field type="date" name="to" />
                            <ErrorMessage
                              name="to"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                        {this.state.biFurcateRentVal === 1 && (
                          <div className="newGridSectionInner">
                            <label>
                              Unit <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name={"rentalLogic.unit"}
                                disabled={this.state.disableOnEdit}
                                value={
                                  this.state.initialValues.rentalLogic.unit
                                }
                                onChange={(e) => {
                                  this.handleUnitOnChange(
                                    e,
                                    values,
                                    setFieldValue
                                  );
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.units.map((obj) => (
                                  <option key={obj.id} value={obj.unitNo}>
                                    {obj.unitNo}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                        )}
                        {this.state.isRentAutocalculate === false &&
                          this.state.showForm && (
                            <>
                              <div className="newGridSectionInner">
                                <label>Period</label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.period"
                                    value={this.state.period}
                                    disabled={this.state.disableOnEdit}
                                    onChange={(e) => {
                                      this.state.period = e.target.value;
                                    }}
                                  />
                                  <ErrorMessage
                                    name="rentalLogic.period"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                              <div className="newGridSectionInner">
                                <label>Period Term</label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="periodTermmYY"
                                        placeholder="YY"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodTermYY}
                                        onChange={(e) => {
                                          this.state.periodTermYY =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(values);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-4">
                                      <Field
                                        type="text"
                                        name="periodTermMM"
                                        placeholder="MM"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodTermMM}
                                        onChange={(e) => {
                                          this.state.periodTermMM =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(values);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-4 p-0">
                                      <Field
                                        type="text"
                                        name="periodTermDD"
                                        placeholder="DD"
                                        disabled={this.state.disableOnEdit}
                                        className="centerPlaceHolder text-center"
                                        value={this.state.periodTermDD}
                                        onChange={(e) => {
                                          this.state.periodTermDD =
                                            e.target.value;
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateToDate(values);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="rentalLogic.periodTerm"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </>
                          )}

                        {this.state.isRentAutocalculate === true && (
                          <>
                            <div className="newGridSectionInner">
                              <label>Escalation %</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.escalationPercent"
                                  disabled={this.state.disableOnEdit}
                                />
                                {this.validator.message(
                                  "Escalation %",
                                  values.rentalLogic.escalationPercent,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>Period Duration</label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-4 p-0">
                                    <Field
                                      type="text"
                                      name="periodDurationYY"
                                      placeholder="YY"
                                      disabled={this.state.disableOnEdit}
                                      className="centerPlaceHolder text-center"
                                      value={this.state.periodDurationYY}
                                      onChange={(e) => {
                                        this.state.periodDurationYY =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <Field
                                      type="text"
                                      name="periodDurationMM"
                                      placeholder="MM"
                                      disabled={this.state.disableOnEdit}
                                      className="centerPlaceHolder text-center"
                                      value={this.state.periodDurationMM}
                                      onChange={(e) => {
                                        this.state.periodDurationMM =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-4 p-0">
                                    <Field
                                      type="text"
                                      name="periodDurationDD"
                                      placeholder="DD"
                                      disabled={this.state.disableOnEdit}
                                      className="centerPlaceHolder text-center"
                                      value={this.state.periodDurationDD}
                                      onChange={(e) => {
                                        this.state.periodDurationDD =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                </div>
                                <ErrorMessage
                                  name="rentalLogic.periodDuration"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {this.state.showForm && (
                          <div className="gridColOneByThree">
                            <div className="newGridSectionInner newGridSectionInnerForLogin">
                              <label>
                                Rental Logic <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalLogicValue"}
                                  value={this.state.initialValues.rentalLogic.rentalLogicValue}
                                  onChange={(e) => {
                                    handleChange(e);
                                    this.handleRentalLogicChange(e, values);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="1" label="Rent Only" />
                                  <option value="2" label="Rent Minus CAM (%)" />
                                  <option value="3" label="Rent Plus Fitout Rent" />
                                  <option value="4" label="Rent Plus Fitout Rent Minus CAM (%)" />
                                  {this.state.isRentAutocalculate === false && (
                                    <>
                                      <option value="5" label="Pure Revenue Share" />
                                      <option value="6" label="Pure Revenue Share Minus CAM (%)" />
                                      <option value="7" label="Pure Revenue Share Sales Range" />
                                      <option value="8" label="Pure Revenue Share Sales Range Minus CAM (%)" />
                                      <option value="9" label="Pure Revenue Share Product Category" />
                                      <option value="10" label="Pure Revenue Share Product Category Minus CAM (%)" />
                                      <option value="11" label="Pure Revenue Share Sales Range Product Category" />
                                      <option value="12" label="Pure Revenue Share Sales Range Product Category Minus CAM (%)" />
                                      <option value="13" label="Minimum Guarantee Rent or Revenue Share (Higher)" />
                                      <option value="14" label="Minimum Guarantee Rent or Revenue Share (Higher) Minus CAM (%)" />
                                      <option value="15" label="Minimum Guarantee (Rent + CAM) or Revenue Share (Higher)" />
                                      <option value="16" label="Minimum Guarantee (Rent + Fitout Rent) or Revenue Share (Higher)" />
                                      <option value="17" label="Minimum Guarantee (Rent + Fitout Rent) or Revenue Share (Higher)  Minus CAM (%)" />
                                      <option value="18" label="Minimum Guarantee Rent or Revenue Share Sales Range (Higher)" />
                                      <option value="19" label="Minimum Guarantee Rent or Revenue Share Sales Range (Higher) Minus CAM (%)" />
                                      <option value="20" label="Minimum Guarantee Rent or Revenue Share Product Category (Higher)" />
                                      <option value="21" label="Minimum Guarantee Rent or Revenue Share Product Category (Higher) Minus CAM (%)" />
                                      <option value="22" label="Minimum Guarantee Rent or Revenue Share Sales Range and Product Category (Higher)" />
                                      <option value="23" label="Minimum Guarantee Rent or Revenue Share Sales Range and Product Category (Higher) Minus CAM (%)" />
                                      <option value="24" label="Minimum Guarantee Rent and Revenue Share (Both)" />
                                      <option value="25" label="Minimum Guarantee Rent and Revenue Share (Both) Minus CAM (%)" />
                                      <option value="26" label="Minimum Guarantee Rent and Revenue Share (Lower)" />
                                      <option value="27" label="Minimum Guarantee Rent and Revenue Share (Lower) Minus CAM (%)" />
                                      <option value="28" label="Minimum Gaurantee Rent and Revenue Share Value Threshold" />
                                    </>
                                  )}
                                </Field>
                              </div>
                            </div>
                          </div>
                        )}


                        {this.state.rentMinusCam && (
                          <>
                            {this.state.isRentAutocalculate === false && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      readOnly
                                      value={this.state.fromDate}
                                      onChange={handleChange}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      readOnly
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={handleChange}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentalUom"
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    this.fetchUnitDetails(e, setFieldValue);
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                  {this.state.initialValues.rentalLogic
                                    .rentalLogicValue == 1 && (
                                    <option value="Per Seat" label="Per Seat" />
                                  )}
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="rentalLogic.onArea"
                                    onChange={handleChange}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}
                            {values.rentalLogic.rentalUom == "Per Seat" && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>Seat Count</label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.seatCount"
                                      onBlur={(e) => {
                                        this.calculateTotalSeatAmount(
                                          e,
                                          values,
                                          "count"
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Seat Count",
                                      values.rentalLogic.seatCount,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>Seat Rate</label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.seatRate"
                                      onBlur={(e) => {
                                        this.calculateTotalSeatAmount(
                                          e,
                                          values,
                                          "rate"
                                        );
                                        this.calculateEscalationPercent(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Seat Rate",
                                      values.rentalLogic.seatRate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>Total Seat Amount</label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.seatTotalAmount"
                                      disabled={this.state.disableOnEdit}
                                    />
                                    {this.validator.message(
                                      "Total Amount",
                                      values.rentalLogic.seatTotalAmount,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            {values.rentalLogic.rentalUom != "Per Seat" && (
                              <div className="newGridSectionInner">
                                <label>
                                  Rent Rate <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="number"
                                    name="rentalLogic.rentRate"
                                    onBlur={(e) => {
                                      this.calculateEscalationPercent(
                                        e,
                                        values,
                                        setFieldValue
                                      );
                                    }}
                                  />
                                  {this.validator.message(
                                    "rent Rate",
                                    values.rentalLogic.rentRate,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentRateTerm"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentFrequency"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                              </div>
                              {this.validator.message(
                                "rent Due Date",
                                values.rentalLogic.rentDueDate,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.rentFitoutMinusCam && (
                          <>
                            {this.state.isRentAutocalculate === false && (
                              <>
                                <div className="newGridSectionInner">
                                  <label>
                                    From <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      name="rentalLogic.fromDate"
                                      readOnly={this.state.readOnEdit}
                                      value={this.state.fromDate}
                                      onChange={handleChange}
                                    />
                                    {this.validator.message(
                                      "From",
                                      this.state.fromDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                                <div className="newGridSectionInner">
                                  <label>
                                    To <span className="astrik">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="date"
                                      readOnly={this.state.readOnEdit}
                                      name="rentalLogic.toDate"
                                      value={this.state.toDate}
                                      onChange={handleChange}
                                    />
                                    {this.validator.message(
                                      "To",
                                      this.state.toDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentalUom"
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="rentalLogic.onArea"
                                    onChange={handleChange}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}
                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentRateTerm"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentFrequency"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rate UOM{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.fitoutUom"
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "fitout Uom",
                                  values.rentalLogic.fitoutUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {/* Fitout On Area */}
                            {values.rentalLogic.fitoutUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>Fitout On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="rentalLogic.fitoutOnArea"
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "Fitout On Area",
                                    values.rentalLogic.fitoutOnArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Fitout Rate */}
                            <div className="newGridSectionInner">
                              <label>Fitout Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.fitoutRate"
                                />
                                <ErrorMessage
                                  name="rentalLogic.fitoutRate"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            {/* Fitout Rate Term */}
                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rate Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.fitoutRateTerm"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Rate Term",
                                  values.rentalLogic.fitoutRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {/* Fitout Rent Frequency */}
                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rent Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.fitoutFrequency"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "fitout Frequency",
                                  values.rentalLogic.fitoutFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.pureRevenueShareMinusCam && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share (%){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.revenueShare"
                                />
                                {this.validator.message(
                                  "Revenue Share %",
                                  values.rentalLogic.revenueShare,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0 dueDateFieldWidth">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-6 pe-0 dueDateFieldWidth">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconcilitation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.pureRevenueSalesShareMinusCam && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => handleChange(e)}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => handleChange(e)}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareTerm"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareFrequency"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShareDueDate"
                                      onChange={handleChange}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueType"
                                      onChange={handleChange}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueFrequency"
                                      onChange={handleChange}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareApplicability"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareReconciliation"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic.revenueShareReconciliation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="gridColOneByThree textWithHrTag bigFonrSize">
                              <h4>Revenue Share (%)</h4>
                              <hr className="m-0" />
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of SLABS <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">FROM</th>
                                      <th scope="col">To</th>
                                      <th scope="col">Revenue Share (%)</th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.initialValues.rentalLogic.slabs
                                      .length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.from`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].from = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .from
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.to`}
                                                onChange={(e) => {
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].to = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index].to
                                                }
                                                onBlur={(e) => {
                                                  if (
                                                    index <
                                                    this.state.initialValues
                                                      .rentalLogic.slabs
                                                      .length -
                                                      1
                                                  ) {
                                                    this.getFromForNextSlab(
                                                      e,
                                                      values,
                                                      index
                                                    );
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .percent
                                                }
                                              />
                                            </td>
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var _slabs =
                                                    this.state.initialValues
                                                      .rentalLogic.slabs;
                                                  _slabs.splice(index, 1);
                                                  this.setState({
                                                    slabs: _slabs,
                                                  });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                    className="form-control"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {this.state.pureRevenueProduct && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => handleChange(e)}
                                  className="form-control"
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => handleChange(e)}
                                  className="form-control"
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                      className="form-control"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                      className="form-control"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareApplicability"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconciliation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic.revenueShareReconciliation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="gridColOneByThree textWithHrTag bigFonrSize">
                              <h4>Revenue Share (%)</h4>
                              <hr className="m-0" />
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of Products{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                            <div className="gridColOneByThree">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">SLAB</th>
                                    <th scope="col">PRODUCT</th>
                                    <th scope="col">Revenue Share (%)</th>
                                    <th scope="col" colSpan="">
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.initialValues.rentalLogic.slabs
                                    .length > 0 &&
                                    this.state.initialValues.rentalLogic.slabs.map(
                                      (slab, index) => (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <Select
                                              className="basic-single custom-select-style"
                                              classNamePrefix="custom-select-style-inner"
                                              isSearchable={true}
                                              name={`rentalLogic.slabs.${index}.product`}
                                              value={{
                                                label: slab.productName,
                                                value: slab.product,
                                              }}
                                              onChange={(e) =>
                                                this.changeProduct(
                                                  e,
                                                  values,
                                                  index
                                                )
                                              }
                                              options={this.state.products.map(
                                                (product) => ({
                                                  label: product.product_name,
                                                  value: product.id,
                                                })
                                              )}
                                            />
                                          </td>
                                          <td>
                                            <Field
                                              type="text"
                                              name={`rentalLogic.slabs.${index}.percent`}
                                              onChange={(e) => {
                                                this.state.initialValues.rentalLogic.slabs[
                                                  index
                                                ].percent = e.target.value;
                                                handleChange(e);
                                              }}
                                              value={
                                                this.state.initialValues
                                                  .rentalLogic.slabs[index]
                                                  .percent
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <a
                                              className="actionDelete"
                                              href="#"
                                              onClick={(e) => {
                                                this.state.initialValues
                                                  .totalSlabs--;
                                                var _slabs =
                                                  this.state.initialValues
                                                    .rentalLogic.slabs;
                                                _slabs.splice(index, 1);
                                                this.setState({
                                                  slabs: _slabs,
                                                });
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faTimes} />
                                            </a>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.pureRevenueSalesProduct && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  {
                                    className: "text-danger",
                                  }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  {
                                    className: "text-danger",
                                  }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareTerm"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareFrequency"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                      className="form-control"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                      className="form-control"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareApplicability"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareReconciliation"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  className="form-control"
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic.revenueShareReconciliation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner"></div>
                            <div className="gridColOneByThree textWithHrTag bigFonrSize">
                              <h4>Revenue Share (%)</h4>
                              <hr className="m-0" />
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of Products & Sales Slabs{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">PRODUCT</th>
                                      <th scope="col">FROM</th>
                                      <th scope="col">TO</th>
                                      <th scope="col">Revenue Share (%)</th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.initialValues.rentalLogic.slabs
                                      .length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (slab, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ width: "200px" }}>
                                              <Select
                                                className="basic-single custom-select-style"
                                                classNamePrefix="custom-select-style-inner"
                                                isSearchable={true}
                                                name={`rentalLogic.slabs.${index}.product`}
                                                value={{
                                                  label: slab.productName,
                                                  value: slab.product,
                                                }}
                                                onChange={(e) => {
                                                  this.changeProduct(
                                                    e,
                                                    values,
                                                    index
                                                  );
                                                }}
                                                options={this.state.products.map(
                                                  (product) => ({
                                                    label: product.product_name,
                                                    value: product.id,
                                                  })
                                                )}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.from`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].from = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={slab.from}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.to`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].to = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={slab.to}
                                                onBlur={(e) => {
                                                  if (
                                                    index <
                                                    this.state.initialValues
                                                      .rentalLogic.slabs
                                                      .length -
                                                      1
                                                  ) {
                                                    this.getFromForNextSlab(
                                                      e,
                                                      values,
                                                      index
                                                    );
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={slab.percent}
                                              />
                                            </td>
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var slabs = [
                                                    ...this.state.initialValues
                                                      .rentalLogic.slabs,
                                                  ];
                                                  slabs.splice(index, 1);
                                                  this.setState({ slabs });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.minimumGuaranteeRentPlusCam && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.onArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share (%){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.revenueShare"
                                />
                                {this.validator.message(
                                  "Revenue Share %",
                                  values.rentalLogic.revenueShare,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareTerm"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareFrequency"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShareDueDate"
                                      onChange={handleChange}
                                    />
                                    {this.validator.message(
                                      "Revenue Share Due Date",
                                      values.rentalLogic.revenueShareDueDate,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueType"
                                      onChange={handleChange}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueFrequency"
                                      onChange={handleChange}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareReconcilitation"
                                  onChange={handleChange}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.minimumGuaranteeRentPlusFitout && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentalUom"
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="rentalLogic.onArea"
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentRateTerm"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentFrequency"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share (%){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.revenueShare"
                                />
                                {this.validator.message(
                                  "Revenue Share %",
                                  values.rentalLogic.revenueShare,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconciliation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic.revenueShareReconciliation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rate UOM{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.fitoutUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Fitout Rate UOM",
                                  values.rentalLogic.fitoutUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.fitoutUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>Fitout On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.fitoutOnArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "Fitout On Area",
                                    values.rentalLogic.fitoutOnArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            <div className="newGridSectionInner">
                              <label>Fitout Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.fitoutRate"
                                />
                                <ErrorMessage
                                  name="rentalLogic.fitoutRate"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rate Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.fitoutRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Fitout Rate Term",
                                  values.rentalLogic.fitoutRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Fitout Rent Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.fitoutFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Fitout Rate Frequency",
                                  values.rentalLogic.fitoutFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state
                          .minimumGuaranteeRentRevenueShareSalesRange && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.onArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareApplicability"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconcilitation
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconcilitation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconcilitation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="gridColOneByThree textWithHrTag bigFonrSize">
                              <h4>Revenue Share (%)</h4>
                              <hr className="m-0" />
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                No. of SLABS <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">FROM</th>
                                      <th scope="col">To</th>
                                      <th scope="col">Revenue Share (%)</th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {this.state.initialValues.rentalLogic.slabs
                                      .length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.from`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].from = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .from
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.to`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].to = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index].to
                                                }
                                                onBlur={(e) => {
                                                  if (
                                                    index <
                                                    this.state.initialValues
                                                      .rentalLogic.slabs
                                                      .length -
                                                      1
                                                  ) {
                                                    this.getFromForNextSlab(
                                                      e,
                                                      values,
                                                      index
                                                    );
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .percent
                                                }
                                              />
                                            </td>
                                            {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var _slabs =
                                                    this.state.initialValues
                                                      .rentalLogic.slabs;
                                                  _slabs.splice(index, 1);
                                                  this.setState({
                                                    slabs: _slabs,
                                                  });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.minimumGuaranteeRentRevenueShareProduct && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="Per Sq Ft"
                                    label="Per Sq Ft"
                                  />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>
                                  On Area
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.onArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                              this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="Per Month"
                                    label="Per Month"
                                  />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option
                                    value="Per Year"
                                    label="Per Year"
                                  />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option
                                    value="Quarterly"
                                    label="Quarterly"
                                  />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="Per Month"
                                    label="Per Month"
                                  />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option
                                    value="Per Year"
                                    label="Per Year"
                                  />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option
                                    value="Quarterly"
                                    label="Quarterly"
                                  />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareApplicability"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic
                                    .revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconcilitation
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconcilitation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option
                                    value="Quarterly"
                                    label="Quarterly"
                                  />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconcilitation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="newGridSectionInner">
                                <label>Revenue Share (%)</label>
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of Products{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={
                                    this.state.initialValues
                                      .totalSlabs
                                  }
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>


                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">PRODUCT</th>
                                      <th scope="col">
                                        Revenue Share (%)
                                      </th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {this.state.initialValues.rentalLogic
                                      .slabs.length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <Select
                                                className="basic-single custom-select-style"
                                                classNamePrefix="custom-select-style-inner"
                                                isSearchable="true"
                                                name={`rentalLogic.slabs.${index}.product`}
                                                value={{
                                                  label:
                                                    this.state
                                                      .initialValues
                                                      .rentalLogic.slabs[
                                                      index
                                                    ].productName,
                                                  value:
                                                    this.state
                                                      .initialValues
                                                      .rentalLogic.slabs[
                                                      index
                                                    ].product,
                                                }}
                                                onChange={(e) => {
                                                  this.changeProduct(
                                                    e,
                                                    values,
                                                    index
                                                  );
                                                }}
                                                options={this.state.products.map(
                                                  (item) => ({
                                                    label:
                                                      item.product_name,
                                                    value: item.id,
                                                  })
                                                )}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent =
                                                    e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[
                                                    index
                                                  ].percent
                                                }
                                              />
                                            </td>
                                            {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var _slabs =
                                                    this.state
                                                      .initialValues
                                                      .rentalLogic.slabs;
                                                  _slabs.splice(index, 1);
                                                  this.setState({
                                                    slabs: _slabs,
                                                  });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM %{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                          </>
                        )}

                        {this.state.minimumGuaranteeRentRevenueShareSalesRangeProduct && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator =
                                      new SimpleReactValidator({
                                        autoForceUpdate: this,
                                      });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="Per Sq Ft"
                                    label="Per Sq Ft"
                                  />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.onArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareApplicability"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconcilitation
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconcilitation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconcilitation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner"></div>

                            <div className="newGridSectionInner">
                              <label>Revenue Share (%)</label>
                            </div>

                            <div className="newGridSectionInner"></div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of Products{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">PRODUCT</th>
                                      <th scope="col">Revenue Share (%)</th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {this.state.initialValues.rentalLogic.slabs
                                      .length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <Select
                                                className="basic-single custom-select-style"
                                                classNamePrefix="custom-select-style-inner"
                                                isSearchable="true"
                                                name={`rentalLogic.slabs.${index}.product`}
                                                value={{
                                                  label:
                                                    this.state.initialValues
                                                      .rentalLogic.slabs[index]
                                                      .productName,
                                                  value:
                                                    this.state.initialValues
                                                      .rentalLogic.slabs[index]
                                                      .product,
                                                }}
                                                onChange={(e) => {
                                                  this.changeProduct(
                                                    e,
                                                    values,
                                                    index
                                                  );
                                                }}
                                                options={this.state.products.map(
                                                  (item) => ({
                                                    label: item.product_name,
                                                    value: item.id,
                                                  })
                                                )}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .percent
                                                }
                                              />
                                            </td>
                                            {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var _slabs =
                                                    this.state.initialValues
                                                      .rentalLogic.slabs;
                                                  _slabs.splice(index, 1);
                                                  this.setState({
                                                    slabs: _slabs,
                                                  });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state
                          .minimumGuaranteeRentRevenueShareSalesRangeProduct && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {values.rentalLogic.rentalUom == "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"rentalLogic.onArea"}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentRateTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareTerm"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareFrequency"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueDate"
                                    ></Field>
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.revenueShareDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Applicability
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.revenueShareApplicability"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option
                                    value="cumulative"
                                    label="Cumulative"
                                  />
                                  <option
                                    value="incremental"
                                    label="Incremental"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Applicability",
                                  values.rentalLogic.revenueShareApplicability,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconcilitation
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={
                                    "rentalLogic.revenueShareReconcilitation"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconcilitation",
                                  values.rentalLogic
                                    .revenueShareReconcilitation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="newGridSectionInner">
                                <label>Revenue Share (%)</label>
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                No. of Products & Sales Slabs{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="rentalLogic.slabNumber"
                                  value={this.state.initialValues.totalSlabs}
                                  className="slabInput"
                                  onChange={(e) => {
                                    this.addSlabRow(e);
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="rentalLogic.slabNumber"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>

                            <div className="gridColOneByThree">
                              <div className="tableContainer p-0 m-0">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th scope="col">SLAB</th>
                                      <th scope="col">PRODUCT</th>
                                      <th scope="col">FROM</th>
                                      <th scope="col">TO</th>
                                      <th scope="col">Revenue Share (%)</th>
                                      <th scope="col" colSpan="">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {this.state.initialValues.rentalLogic.slabs
                                      .length > 0 &&
                                      this.state.initialValues.rentalLogic.slabs.map(
                                        (friend, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ width: "200px" }}>
                                              <Select
                                                className="basic-single custom-select-style"
                                                classNamePrefix="custom-select-style-inner"
                                                isSearchable="true"
                                                name={`rentalLogic.slabs.${index}.product`}
                                                value={{
                                                  label:
                                                    this.state.initialValues
                                                      .rentalLogic.slabs[index]
                                                      .productName,
                                                  value:
                                                    this.state.initialValues
                                                      .rentalLogic.slabs[index]
                                                      .product,
                                                }}
                                                onChange={(e) => {
                                                  this.changeProduct(
                                                    e,
                                                    values,
                                                    index
                                                  );
                                                }}
                                                options={this.state.products.map(
                                                  (item) => ({
                                                    label: item.product_name,
                                                    value: item.id,
                                                  })
                                                )}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.from`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].from = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .from
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.to`}
                                                onChange={(e) => {
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].to = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index].to
                                                }
                                                onBlur={(e) => {
                                                  if (
                                                    index <
                                                    this.state.initialValues
                                                      .rentalLogic.slabs
                                                      .length -
                                                      1
                                                  ) {
                                                    this.getFromForNextSlab(
                                                      e,
                                                      values,
                                                      index
                                                    );
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <Field
                                                type="text"
                                                name={`rentalLogic.slabs.${index}.percent`}
                                                onChange={(e) => {
                                                  console.log(e.target.value);
                                                  this.state.initialValues.rentalLogic.slabs[
                                                    index
                                                  ].percent = e.target.value;
                                                  handleChange(e);
                                                }}
                                                value={
                                                  this.state.initialValues
                                                    .rentalLogic.slabs[index]
                                                    .percent
                                                }
                                              />
                                            </td>
                                            {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                            <td>
                                              <a
                                                className="actionDelete"
                                                href="#"
                                                onClick={(e) => {
                                                  this.state.initialValues
                                                    .totalSlabs--;
                                                  var _slabs =
                                                    this.state.initialValues
                                                      .rentalLogic.slabs;
                                                  _slabs.splice(index, 1);
                                                  this.setState({
                                                    slabs: _slabs,
                                                  });
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                />
                                              </a>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {this.state.minimumGuaranteeRentRevenueShareMinimum && (
                          <>
                            <div className="newGridSectionInner">
                              <label>
                                From <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.fromDate"
                                  value={this.state.fromDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "From",
                                  this.state.fromDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                To <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="rentalLogic.toDate"
                                  value={this.state.toDate}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                {this.validator.message(
                                  "To",
                                  this.state.toDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Rent UOM <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name={"rentalLogic.rentalUom"}
                                  onChange={(e) => {
                                    this.validator = new SimpleReactValidator({
                                      autoForceUpdate: this,
                                    });
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue,
                                      "uom"
                                    );
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Sq Ft" label="Per Sq Ft" />
                                  <option
                                    value="Flat Amount"
                                    label="Flat Amount"
                                  />
                                </Field>
                                {this.validator.message(
                                  "Rent UOM",
                                  values.rentalLogic.rentalUom,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            {values.rentalLogic.rentalUom === "Per Sq Ft" && (
                              <div className="newGridSectionInner">
                                <label>On Area</label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="rentalLogic.onArea"
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Usable Area"
                                      label="Usable Area"
                                    />
                                    <option
                                      value="Carpet Area"
                                      label="Carpet Area"
                                    />
                                    <option
                                      value="Gross Leasable Area"
                                      label="Gross Leasable Area"
                                    />
                                  </Field>
                                  {this.validator.message(
                                    "On Area",
                                    values.rentalLogic.onArea,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}

                            {this.state.period > 1 &&
                              typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ] !== "undefined" &&
                              ((typeof this.state.rentalDetails[
                                this.state.escalationIndex
                              ].seatRate !== "undefined" &&
                                this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].seatRate !== 0) ||
                                (typeof this.state.rentalDetails[
                                  this.state.escalationIndex
                                ].rentRate !== "undefined" &&
                                  this.state.rentalDetails[
                                    this.state.escalationIndex
                                  ].rentRate !== 0)) &&
                              this.state.isRentAutocalculate === false && (
                                <div className="newGridSectionInner">
                                  <label>
                                    Escalation %{" "}
                                    {
                                      this.state.rentalDetails[
                                        this.state.escalationIndex
                                      ].seatRate
                                    }
                                  </label>
                                  <div className="position-relative">
                                    <Field
                                      type="number"
                                      name="rentalLogic.escalationPercent"
                                      disabled={this.state.disableOnEdit}
                                      onBlur={(e) => {
                                        this.calculateRentRate(
                                          e,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                    {this.validator.message(
                                      "Escalation %",
                                      values.rentalLogic.escalationPercent,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="newGridSectionInner">
                              <label>Rent Rate</label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.rentRate"
                                  onBlur={(e) => {
                                    this.calculateEscalationPercent(
                                      e,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                                {this.validator.message(
                                  "rent Rate",
                                  values.rentalLogic.rentRate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Rate Term <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentRateTerm"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "rent Rate Term",
                                  values.rentalLogic.rentRateTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Frequency <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.rentFrequency"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "rent Frequency",
                                  values.rentalLogic.rentFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Rent Due Date <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.rentDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueType"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      name="rentalLogic.rentDueFrequency"
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "rent Due Date",
                                  values.rentalLogic.rentDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share (%){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="number"
                                  name="rentalLogic.revenueShare"
                                />
                                {this.validator.message(
                                  "Revenue Share %",
                                  values.rentalLogic.revenueShare,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Term{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareTerm"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Per Month" label="Per Month" />
                                  <option
                                    value="Per Quarter"
                                    label="Per Quarter"
                                  />
                                  <option
                                    value="Per Half Year"
                                    label="Per Half Year"
                                  />
                                  <option value="Per Year" label="Per Year" />
                                  <option value="Per Day" label="Per Day" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Term",
                                  values.rentalLogic.revenueShareTerm,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Frequency{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareFrequency"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Frequency",
                                  values.rentalLogic.revenueShareFrequency,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Due Date{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <div className="row m">
                                  <div className="col-sm-6 ps-0">
                                    <Field
                                      type="number"
                                      name="rentalLogic.revenueShareDueDate"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 pe-0">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueType"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option value="Date" label="Date" />
                                      <option value="Days" label="Days" />
                                      <option
                                        value="Working Day"
                                        label="Working Day"
                                      />
                                    </Field>
                                  </div>
                                  <div className="col-sm-12 p-0 mt-3">
                                    <Field
                                      as="select"
                                      name="rentalLogic.revenueShareDueFrequency"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Every Month"
                                        label="Every Month (Advanced Rent)"
                                      />
                                      <option
                                        value="Subsequent Month"
                                        label="Subsequent Month (Arrears Rent)"
                                      />
                                      <option
                                        value="Subsequent Quarter"
                                        label="Subsequent Quarter"
                                      />
                                      <option
                                        value="Subsequent Half Year"
                                        label="Subsequent Half Year"
                                      />
                                      <option
                                        value="Subsequent Year"
                                        label="Subsequent Year"
                                      />
                                      <option
                                        value="Next Financial Year"
                                        label="Next Financial Year"
                                      />
                                    </Field>
                                  </div>
                                </div>
                                {this.validator.message(
                                  "Revenue Share Due Date",
                                  values.rentalLogic.revenueShareDueDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Revenue Share Reconciliation{" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="rentalLogic.revenueShareReconciliation"
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="Daily" label="Daily" />
                                  <option value="Monthly" label="Monthly" />
                                  <option value="Quarterly" label="Quarterly" />
                                  <option
                                    value="Half Yearly"
                                    label="Half Yearly"
                                  />
                                  <option value="Yearly" label="Yearly" />
                                </Field>
                                {this.validator.message(
                                  "Revenue Share Reconciliation",
                                  values.rentalLogic.revenueShareReconciliation,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            {this.state.showMinusCam && (
                              <div className="newGridSectionInner">
                                <label>
                                  Minus CAM % <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rentalLogic.minusCamPercent"
                                  />
                                  {this.validator.message(
                                    "Minus CAM %",
                                    values.rentalLogic.minusCamPercent,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        <div className="gridColOneByThree">
                          <label>Notes/Remarks</label>
                          <Field
                            as="textarea"
                            className="my-2"
                            name="notes_4"
                          />
                        </div>
                      </div>
                      {this.state.showAddBtn && (
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          {this.state.isRentAutocalculate === false && (
                            <button
                              type="button"
                              onClick={(e) => {
                                this.addRentalDetails(
                                  values,
                                  resetForm,
                                  setFieldValue
                                );
                              }}
                              className="add_button"
                            >
                              Add
                            </button>
                          )}
                          {this.state.isRentAutocalculate === true && (
                            <button
                              type="button"
                              className="add_button"
                              onClick={(e) => {
                                this.calculateRent(values, resetForm);
                              }}
                            >
                              Create
                            </button>
                          )}
                          <button
                            type="button"
                            className="reset_button"
                            onClick={(e) => {
                              this.resetRentalDetails(values, resetForm);
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      )}

                      <div className="rentals">
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term (YY-MM-DD)</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Rental Logic</th>
                                <th scope="col">Rate/ Flat Amount</th>
                                {this.state.isRentAutocalculate === false && (
                                  <th scope="col" colSpan="2">
                                    Action
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.rentalDetails.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <tr key={"rentalTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="popupLink"
                                        onClick={(e) => {
                                          this.state.popupData = name;
                                          this.openModal();
                                        }}
                                      >
                                        {name.period}
                                      </a>
                                    </td>
                                    <td>
                                      {name.periodTermYY == ""
                                        ? "0"
                                        : name.periodTermYY}
                                      {"-"}
                                      {name.periodTermMM == ""
                                        ? "0"
                                        : name.periodTermMM}
                                      {"-"}
                                      {name.periodTermDD == ""
                                        ? "0"
                                        : name.periodTermDD}
                                    </td>
                                    <td>{leaseDateFormat(name.fromDate)}</td>
                                    <td>{leaseDateFormat(name.toDate)}</td>
                                    <td>{name.rentalLogicText}</td>
                                    <td>
                                      {name.rentalUom == "Flat Amount"
                                        ? Number(name.rentRate).toFixed(2)
                                        : ((name.rentalUom == "Per Seat") ?
                                          name.seatRate : name.rentRate
                                        )

                                        // name.rentRate == "" ||
                                        //   name.rentRate == undefined
                                        //   ? name.seatRate == "" ||
                                        //     name.seatRate == undefined
                                        //     ? "-"
                                        //     : name.seatRate
                                        //   : name.rentRate
                                      }
                                    </td>
                                    {this.state.isRentAutocalculate ===
                                      false && (
                                      <td>
                                        <button
                                          type="button"
                                          className="tableActionEdit rentalEdit"
                                          onClick={(e) => {
                                            this.editRental(
                                              index,
                                              values,
                                              setFieldValue
                                            );
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {this.state.rentalDetails.length ==
                                          index + 1 && (
                                          <button
                                            type="button"
                                            className="actionDelete rentalDeleteButton"
                                            onClick={(e) => {
                                              this.handleReset();

                                              this.setState({
                                                delete: true,
                                                index_val: index,
                                                revalue: values.from,
                                              });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                );
                              },
                              this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className='reset_button'>
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </>
            )}
          </Formik>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row">
                        <div className="col-lg-12">
                          <ul>
                            <li>Basic Rental Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.rentalPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">
                "Are you sure you want to delete this period?"
              </p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }

  rentalPopup(rental) {
    console.log(rental);
    if (rental.rentalLogicValue == 1 || rental.rentalLogicValue == 2) {
      return this.rentMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 3 || rental.rentalLogicValue == 4) {
      return this.rentPlusFitoutMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 5 || rental.rentalLogicValue == 6) {
      return this.pureRevenueShareMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 7 || rental.rentalLogicValue == 8) {
      return this.pureRevenueShareSalesRangeMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 9 || rental.rentalLogicValue == 10) {
      return this.pureRevenueShareProductMinusCamPopup(rental);
    } else if (rental.rentalLogicValue == 11 || rental.rentalLogicValue == 12) {
      return this.pureRevenueShareSalesRangeProductMinusCamPopup(rental);
    } else if (
      rental.rentalLogicValue == 13 ||
      rental.rentalLogicValue == 14 ||
      rental.rentalLogicValue == 15
    ) {
      return this.minimumGuaranteeRentPlusCamMinusCam(rental);
    } else if (rental.rentalLogicValue == 16 || rental.rentalLogicValue == 17) {
      return this.minimumGuaranteeRentPlusFitoutRevenueShareMinusCam(rental);
    } else if (
      rental.rentalLogicValue == 18 ||
      rental.rentalLogicValue == 19 ||
      rental.rentalLogicValue == 28
    ) {
      return this.minimumGuaranteeRentRevenueShareSalesMinusCam(rental);
    } else if (rental.rentalLogicValue == 20 || rental.rentalLogicValue == 21) {
      return this.minimumGuaranteeRentRevenueShareProductMinusCam(rental);
    } else if (rental.rentalLogicValue == 22 || rental.rentalLogicValue == 23) {
      return this.minimumGuaranteeRentRevenueShareSalesProductMinusCam(rental);
    } else if (
      rental.rentalLogicValue == 24 ||
      rental.rentalLogicValue == 25 ||
      rental.rentalLogicValue == 26 ||
      rental.rentalLogicValue == 27
    ) {
      return this.minimumGuaranteeRentOrRevenueShareMinusCam(rental);
    }
  }

  rentMinusCamPopup(rental) {
    if (this.state.isRentAutocalculate === false) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                    {"-"}
                    {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                    {"-"}
                    {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {/* {leaseDateFormat(rental.fromDate)} */}
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {/* {leaseDateFormat(rental.toDate)} */}
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            {rental.escalationPercent != undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Escalation Percent <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.escalationPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}

            {rental.rentalUom == "Per Seat" && (
              <>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Seat Count <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {rental.seatCount}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Seat Rate <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {rental.seatRate}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Seat Total Amount <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {rental.seatTotalAmount}
                      </label>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            {rental.rentalUom != "Per Seat" && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Rent Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.rentRate}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Duration <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodDurationYY == ""
                      ? "0"
                      : rental.periodDurationYY}
                    {"-"}
                    {rental.periodDurationMM == ""
                      ? "0"
                      : rental.periodDurationMM}
                    {"-"}
                    {rental.periodDurationDD == ""
                      ? "0"
                      : rental.periodDurationDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
            {rental.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  rentPlusFitoutMinusCamPopup(rental) {
    if (this.state.isRentAutocalculate === false) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                    {"-"}
                    {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                    {"-"}
                    {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            {rental.escalationPercent != undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Escalation Percent <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.escalationPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutOnArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutFrequency}
                  </label>
                </div>
              </div>
            </div>
            {rental.rentalLogicText.includes("Minus CAM") && (
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Minus CAM % <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.minusCamPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="popupHeading">{rental.rentalLogicText}</h4>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.period}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Period Duration <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.periodDurationYY == ""
                      ? "0"
                      : rental.periodDurationYY}
                    {"-"}
                    {rental.periodDurationMM == ""
                      ? "0"
                      : rental.periodDurationMM}
                    {"-"}
                    {rental.periodDurationDD == ""
                      ? "0"
                      : rental.periodDurationDD}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
            {rental.unit !== undefined && (
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Unit <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.unit}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rental Logic <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalLogicText}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    From <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.fromDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    To <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {leaseDateFormat(rental.toDate)}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentalUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.onArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentFrequency}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Rent Due Date <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.rentDueDate}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate UOM <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutUom}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout On Area <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutOnArea}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRate}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rate Term <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutRateTerm}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Fitout Rent Frequency <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.fitoutFrequency}
                  </label>
                </div>
              </div>
            </div>
            {rental.rentalLogicText.includes("Minus CAM") && (
              <div className="col-lg-6 fitoutPopup">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Minus CAM % <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {rental.minusCamPercent}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  pureRevenueShareMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.escalationPercent != undefined && (
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Escalation Percent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.escalationPercent}
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pureRevenueShareSalesRangeMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.escalationPercent != undefined && (
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Escalation Percent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.escalationPercent}
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pureRevenueShareProductMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.escalationPercent != undefined && (
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Escalation Percent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.escalationPercent}
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pureRevenueShareSalesRangeProductMinusCamPopup(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.escalationPercent != undefined && (
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Escalation Percent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.escalationPercent}
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">From</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentPlusCamMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  minimumGuaranteeRentPlusFitoutRevenueShareMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutOnArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12 fitoutPopup revenue">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Fitout Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.fitoutFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        {rental.rentalLogicText.includes("Minus CAM") && (
          <div className="row">
            <div className="col-lg-12 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareSalesMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareProductMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentRevenueShareSalesProductMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Applicability <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareApplicability}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0 m-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">Product</th>
                          <th scope="col">From</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rental.slabs.length > 0 &&
                          rental.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.productName}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  minimumGuaranteeRentOrRevenueShareMinusCam(rental) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="popupHeading">{rental.rentalLogicText}</h4>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.period}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.periodTermYY == "" ? "0" : rental.periodTermYY}
                  {"-"}
                  {rental.periodTermMM == "" ? "0" : rental.periodTermMM}
                  {"-"}
                  {rental.periodTermDD == "" ? "0" : rental.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rental Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(rental.toDate)}
                </label>
              </div>
            </div>
          </div>
          {rental.escalationPercent != undefined && (
            <div className="col-lg-6">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Escalation Percent <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.escalationPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentalUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.onArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Rent Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.rentDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareDueDate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6 fitoutPopup">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Revenue Share Reconcilitation{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {rental.revenueShareReconcilitation}
                </label>
              </div>
            </div>
          </div>
          {rental.rentalLogicText.includes("Minus CAM") && (
            <div className="col-lg-6 fitoutPopup">
              <div className="inputContainer col-lg-12 col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label">
                    Minus CAM % <span className="astrik">*</span>
                  </label>
                  <label className="col-sm-7 col-form-label">
                    {rental.minusCamPercent}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(RentalDetails);
